import FeatureFlagService from 'src/services/feature-flag-service';
import {UserIdentifier} from 'src/types/enums';

export const SET_ACCESSIBILITY_ANNOUNCEMENT = 'SET_ACCESSIBILITY_ANNOUNCEMENT';

const accessibilityAnnouncement = (announcement) => ({
  type: SET_ACCESSIBILITY_ANNOUNCEMENT,
  announcement,
});

// Delay dispatch of accessibilityAnnouncement so
// that the screen reader doesn't miss it.
export const setAccessibilityAnnouncement = (announcement) => (dispatch) => {
  setTimeout(() => {
    dispatch(accessibilityAnnouncement(announcement));
  }, 50);
};

export const setNavigationAnnouncement = (page) => async (dispatch, getState) => {
  const {userIdentifier} = getState();
  const isCollegePortalUser = userIdentifier === UserIdentifier.CP_USER;

  let brandName = 'Raise Me';
  if (isCollegePortalUser) {
    const {leadGenerationLogoFlag} = await FeatureFlagService.getFeatureFlagStatuses([
      'leadGenerationLogoFlag',
    ]);
    if (leadGenerationLogoFlag) {
      brandName = 'Lead Generation';
    }
  }

  document.title = `${brandName} - ${page}`;
  dispatch(setAccessibilityAnnouncement(`Navigated to ${page}`));
};
